<div class="tableau_container">
  <div class="tableauViz"></div>
  <a href="https://dub01.online.tableau.com/auth/logout" class="my-5 d-none"> Sign out </a>
</div>
